import AiTraining from './AiTraining';

export default AiTraining;
